import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  grid: {
    justifyContent: 'center',
    paddingTop: '5%',
  },
  divider: {
    margin: 'auto',
  },
}));
